import React, { useState } from 'react';
import { Typography, Box } from '@mui/material';
import { Footer } from '../Footer';
import HeroContainer from '../ui/hero-container';
import OrangeButton from '../buttons/orange-button';

import { useNavigate } from 'react-router-dom';
import HeaderAlt from '../HeaderAlt';

const Advisors = () => {
  const [expandedIndexes, setExpandedIndexes] = useState([]);

  const toggleReadMore = (index) => {
    setExpandedIndexes(
      (prevIndexes) =>
        prevIndexes.includes(index)
          ? prevIndexes.filter((i) => i !== index) // Collapse
          : [...prevIndexes, index] // Expand
    );
  };

  const navigate = useNavigate();

  const advisoryBoardMembers = [
    {
      name: 'Robert Wagnon',
      role: 'Founder and Chief Executive Officer of Republic State Mortgage Company',
      expertise: 'Business Management and Strategy',
      references: {
        linkedIn: 'https://www.linkedin.com/in/robert-wagnon-2229a0/',
        companyWebsite: 'https://www.republicstatemortgage.com/',
      },
      profilePicture: '/images/icons/advisor-profile-pics/Robert.svg', // @Ajay why are these stored in a folder named icons? Is it because their SVGs? Let's organize this better and create a folder for profile pictures
      biography: `
        Robert Wagnon is the founder and Chief Executive Officer of Republic State Mortgage Company. 
        Through Robert's unique philosophy of employee growth and satisfaction, the company has steadily 
        grown since its inception in 1994 from one office in Houston, Texas with 1 employee to in 
        excess of 25 offices with over 200 employees. In 2018, 2019, and 2020 Republic State Mortgage 
        was named a top workplace by the Houston Chronicle and named a best mortgage company to work 
        for by the National Mortgage News in 2019, 2020, and 2021. In 2021, Fortune named Republic a 
        best workplace in the financial services and insurance sector.
        \n\n
        Robert serves or has served on the board of directors or the advisory board of the following 
        institutions: Sul Ross University Foundation, Texas Mortgage Bankers Association; Houston 
        Mortgage Bankers Association; Entrepreneurs Organization (EO); World Entrepreneurs 
        Organization (WEO); Main Street Theater; Sterling Bank; and the St. Philips Episcopal Church 
        of Uvalde. For 10 years, Robert served as Cub Master, Assistant Scout Master and Scout Master 
        for Pack 695 and Troop 354 in the Sam Houston Area Council of Boy Scouts of America.
        \n\n
        A seventh-generation Texan, Robert resides in Houston, Texas with his wife, Ellen Weingarten
        Wagnon. Robert enjoys traveling and adventures with Ellen and their three sons, Reagor, 
        Joseph and Bennett. Robert is an avid and passionate outdoorsman and pilot. He shoots skeet, 
        trap and sporting clays weekly. In addition to fishing when and wherever possible, Robert 
        loves to bird hunt at his ranch in Uvalde, Texas. Prior to his current professional career, 
        Robert made his living in the outdoors by backpacking on fire watch through most of southern 
        Alaska, the Yukon Territory and northern British Columbia for the U.S. Forestry Service and 
        private forestry interests and also fished commercially for the better part of a year off 
        Kodiak Island, Alaska. Robert spent two years in the Merchant Marine and was a Merchant Marine 
        Staff Officer, serving as purser on the S.S. Independence out of Honolulu, Hawaii.
        \n\n

      `,
    },
    {
      name: 'Robin Doran',
      role: 'Founding Partner and Lead Counselor',
      expertise: 'Educational and College Counselling Services',
      references: {
        linkedIn: null,
        companyWebsite: 'https://www.doranandscalora.com/',
      },
      profilePicture: '/images/icons/advisor-profile-pics/Robin.svg',
      biography: `
        Robin's career in admission actually began as an undergraduate student at Southern Methodist 
        University, where she was a tour guide, student panelist, and intern in the Office of Admission. 
        After graduating, she became a professional member of the office as an admission counselor. 
        After one year in the office, Robin married one of those crazy actor types, so they packed up 
        and moved to Los Angeles for her husband Justin to pursue his MFA in acting at UCLA, and Robin 
        began her time in the Office of Admission at the University of Southern California. During the 
        five years Robin was at USC, she moved from Assistant Director to Senior Associate Director of 
        Admission in charge of recruitment. Robin loved her time at USC and remains an avid Trojan 
        fan to this day.
        \n\n
        After the birth of her second child, life on the road of an admission officer was very 
        difficult for her family, so Robin decided to make a change to the “other side of the desk” 
        at Oaks Christian School in Westlake Village, California. When Robin was hired at Oaks, the 
        school had not yet opened. She was appointed the inaugural Director of Admission and College 
        Counselor since they wouldn't have seniors for a couple of years. Robin was hired in March of 
        2000, and there were no students enrolled at the school. That August, the school opened with 
        200 students in grades 6, 9, and 10, and today, Oaks is a thriving school with 1400 students 
        and excellent academic, athletic, and arts programs.
        \n\n
        In 2003, Robin and her family decided to move to Houston to help her mother-in-law as she 
        neared the end of her long battle with cancer. They planned to be in Houston for a couple of 
        years and then return to Los Angeles. As those things typically go, more than 20 years later, 
        the Dorans are still proud Houstonians.
        \n\n
        After one year helping out at The John Cooper School as a part-time college counselor, Robin 
        became the Associate Director of College Counseling at The Kinkaid School. She helped to 
        bring the dean system to Kinkaid in the fall of 2008, which created a much more student-centered, 
        relationship-based approach to college counseling that serves as the model for our approach to
        private counseling at doran+scalora college consulting.
        \n\n
        In 2010, Robin became the Lead Upper School Dean, and she served on the Administrative team 
        of the school. In addition to all her responsibilities as dean, Robin started the Habitat 
        service program, served on the Admission Committee, was an adviser to the Peer Mentor program, 
        served on numerous search committees, and started the Big Sister/Little Sister program.
        \n\n
        In order to help more students understand the college admission process, Robin joined the Board 
        of Directors at One Goal Houston in 2019. One Goal works to solve the degree divide in our 
        lifetime so that all students have the opportunity to graduate from college.
        \n\n
        Personally, Robin's husband, Justin, is an actor, director, and the incoming Associate Head 
        of School at St. Francis Episcopal School. They have three children, Ty, Kinkaid '16 and 
        Northwestern '20, Caleigh, Kinkaid '18, Vanderbilt '22, and Harvard Law '25, Jackson, Kinkaid 
        '22 and USC '26.
      `,
    },
    {
      name: 'Robert (Bob) McPherson',
      role: 'Distinguished Professor of Psychological, Health, and Learning Sciences',
      expertise: 'Educational Entrepreneurship',
      references: {
        linkedIn: 'https://www.linkedin.com/in/bob-mcpherson-71593443/',
        companyWebsite: 'https://www.coe.uh.edu/dir/coedirectory/faculty_template.cfm?id=83',
      },
      profilePicture: '/images/icons/advisor-profile-pics/Bob.svg',
      biography: `
        McPherson recently served as special assistant to the president, co-chairing two task forces 
        to address suicide prevention & promotion of mental health on campus. He served as interim 
        senior vice chancellor for the UH System & UH provost from Aug., 2022 thru Jan., 2023. 
        \n\n
        As dean of the College of Education from 2011-2022, he oversaw increased funded research & 
        scholarship efforts, the unit's historic fundraising effort, transformation of the teacher 
        education program, launch of two new Ph.D. programs, & other academic gains. His prior 
        service in the college included executive associate dean, associate dean of graduate studies, 
        department chairperson, & director of the Ph.D. in counseling psychology. His other academic 
        leadership positions have included service as interim associate provost for academic affairs 
        & operations for the UH launch at the Sugar Land & Katy campuses, assistant to the vice 
        chancellor for student affairs, & coordinator of learning support services, & staff 
        psychologist at the UH psychological services center.
        \n\n
        He was co-founder of Psychological Software Solutions, Inc., a software start-up buisiness 
        providing behavioral progress monitoring systems for large urban school districts that was 
        serving over 2,000,000 students when the company was acquired by Pearson's Clinical Assessment 
        Group. Currently, he is a board member for Attend, a software company providing parent training 
        for famlies with autistic children. He was also co-founding faculty member of the Houston 
        Psychotherapy Institute, a non-profit, sliding scale fee-for-service and clinical training 
        site for psychologists.
        \n\n
        He is a fellow of the American Educational Research Assocaition and American Psychological 
        Association & member of the National Academies of Practice. He is past president of the APA 
        Council of Counseling Psychology Training Programs, the Texas & Houston Psychological 
        Associations & recipient of the Texas Association of Colleges for Teacher Education's Robert 
        B. Howsam Award for his leadership efforts at the state and national levels. 
        \n\n
        His board service includes the Council of Academic Deans of Research Education Institutions, 
        the Houston Forensic Science Center, the UH Charter School, & the TLC Foundation for 
        Body-Focused Repetitive Disorders. He is also a member of the Houston Livestock Show and 
        Rodeo International Committee & served on the Greater Houston Partnership's Education 
        Committee for eleven years.
        \n\n
        McPherson began his career as a classroom teacher and guidance counselor at a high-poverty 
        Title I school in Odessa,Texas.
      `,
    },
    {
      name: 'Alan Charles (Chuck) Weiner',
      role: 'President, ALAN CHARLES WEINER PC',
      expertise: 'Accounting',
      references: {
        linkedIn: 'https://www.linkedin.com/in/alan-charles-chuck-weiner-cpa-a4372618/',
        companyWebsite: null,
      },
      profilePicture: '/images/default-profile-pics/male-default.png',
      biography: '', //TODO @Mason get biography for Chuck
    },
    {
      name: 'Kara Mings',
      role: 'CPA, Executive Vice President, Director of C&I Lending/Regional Credit Officer',
      expertise: 'Finance',
      references: {
        linkedIn: 'https://www.linkedin.com/in/kara-mings-a3885b17b/',
        companyWebsite: 'https://www.stellar.bank/',
      },
      profilePicture: '/images/icons/advisor-profile-pics/Kara.svg',
      biography: `
        Kara is responsible for Commercial and Industrial Lending (C&I) for Stellar Bank 
        overseeing the underwriting, monitoring, and policies for the portfolio. She serves as a 
        regional credit officer for the bank approving loans and serving on loan and risk management 
        committees. Kara serves as the primary liaison with the bank's internal audit team as well 
        as bank examiners for the credit department. She is the system owner for Stellar Bank's loan 
        origination system. She teaches C&I Lending for the ABA Banking School.
        \n\n
        Prior to joining Stellar Bank, she was a financial advisor serving as an independent consultant
        for companies, trusts, and individuals evaluating client's financial objectives, risk tolerance,
        and strategic plans. She worked with clients to design report rationalization and key KPIs/Metrics,
        identified key business drivers that impacted financial results, and created client driven
        empowerment solutions to align with the company's purpose and initiatives.
        \n\n
        Kara has over 35 years of experience in the financial industry. As a financial management
        professional, she has brought her expertise to various banking positions including corporate 
        and commercial lending, trust, and credit with Bank of America, BBVA Compass Bank, and JP
        Morgan Chase.
        \n\n
        Kara has served on numerous committees and board of directors for non-profit, civic, and
        professional organizations. Kara is in the Greater Houston Partnership's Executive Women's
        Group and a GHWCC Thought Leader. She is currently serving on the Board of Directors for
        Child Advocates, Greg Gephart Foundation, Ragnot Amateur Sailing Association, and LA2028
        for USA Field Hockey. She is a member of SFNet-Houston, Texas Society of CPAs, and various
        other professional organizations.
        \n\n
        Kara has a BBA-Finance from the University of Oklahoma, BBA-Accounting from the
        University of Houston and is a Certified Public Accountant. She completed the Executive
        Management and Leadership program at MIT Sloan School of Management.
      `,
    },
    {
      name: 'Carol Burke',
      role: 'Partner', // WHICH LAW FIRM? TODO @MASON GET A BETTER BIO
      expertise: 'Business Law',
      references: {
        linkedIn: 'https://www.linkedin.com/in/carol-burke-700642b/',
        companyWebsite: null,
      },
      profilePicture: '/images/icons/advisor-profile-pics/Carol.svg',
      biography: `
        Carol Burke chose to pursue a career in law after completing undergraduate studies. She 
        attended University of Houston Law Center and graduated in 1983. That same year, she passed 
        the bar exam and was admitted to legal practice in 1983.
        \n\n
        Carol M. Burke is an attorney who represents clients in the Houston, Texas area. Carol Burke
        is recognized by peers and was selected to Super Lawyers for 2017 - 2018. This selection is 
        based off of an evaluation of 12 indicators including peer recognition and professional 
        achievement in legal practice. Being selected to Super Lawyers is limited to a small number 
        of attorneys in each state. As one of the few attorneys to garner the distinction of Super 
        Lawyers, Carol Burke has earned the respect of peers as one of the top-rated attorneys in the 
        United States.
      `,
    },
    {
      name: 'Jim Repass',
      role: 'Retired Intellectual Property Attorney',
      expertise: 'IP Law',
      references: {
        linkedIn: 'https://www.linkedin.com/in/jimrepass/',
        companyWebsite: null,
      },
      profilePicture: '/images/icons/advisor-profile-pics/Jim.svg',
      biography: `
        Jim Repass is a retired intellectual property attorney with a distinguished career that 
        includes counseling clients on IP aspects of business transactions, such as mergers, 
        acquisitions, joint ventures, research and development, and licensing arrangements. Over the 
        years, he led numerous IP due diligence investigations and negotiated a wide range of agreements, 
        including licensing, joint ventures, mergers, asset purchases, and confidentiality agreements.
        \n\n
        Jim's litigation practice covered patent, trademark, trade secret, and copyright disputes, 
        where he represented both plaintiffs and defendants, often handling cases through appeal. 
        Beyond litigation, Jim also advised clients on IP strategy, managing IP estates, conducting 
        patentability and freedom-to-practice investigations, devising protection strategies for new 
        products, and addressing potential infringement and misappropriation issues. Known for his 
        extensive expertise, Jim also served as the U.S. Head of Intellectual Property for Norton Rose 
        Fulbright, shaping the firm's approach to complex IP matters.
      `,
    },
    {
      name: 'Daniel Wong',
      role: 'Senior Solutions Architect ',
      expertise: 'Engineering Architecture',
      references: {
        linkedIn: 'https://www.linkedin.com/in/danielwong1/',
        companyWebsite: 'https://www.rbc.com/about-rbc.html',
      },
      profilePicture: '/images/icons/advisor-profile-pics/Daniel.svg',
      biography: `
        Solutions architect 15+ years. SME of Payments (2018+), Financial Crimes including Fraud 
        (2020+), AML (2020+), KYC (2020+), Kafka (2016+), Personal/Commercial Banking, cheque processing. 
        Vendor integrations FIS, ACI, IBM, LexisNexis, SymphonyAI. Cloud AWS, Azure. Collaborative 
        problem-solver, providing simple end-user experience on multifaceted applications. 
        Abstraction of data, messages, APIs, flows, and application logic towards rapid polymorphic 
        adaptation.
        \n\n
        Demonstrated track record of optimizing performance, flows, and interactions. 
        Customer focused team lead, prioritizing work based on customers needs. Technical and consensus 
        leader. Hands-on. Strong communicator, working closely with different groups. Architect for 
        9 new solutions.
        \n\n
        AWARDS:
        \n
        • Gold Award Innovation (Ciena)\n
        • Silver Award Customer Focus (Ciena)\n
        • Bronze Award Leadership, Technical Direction, Innovation (3 times Ciena)\n
        • Patent Review Board “Optimistic Transactions” (Ciena)\n
        • Gold Award of Distinction Customer Service and Performance Breakthrough (Ciena)\n
        • Top Talent Award (4 times Nortel)\n
        • Design Infrastructure Award of Merit 'Shareholder Value' (Nortel)\n
        \n\n
        TECHNICAL SKILLS:
        \n
        ✔ Operating Systems: Linux, Unix, Windows, Mac\n
        ✔ Database: MongoDB, Cassandra, MySQL, Oracle (15 yrs), ObjectStore\n
        ✔ Internet / Web Technologies: API Gateway, Swagger/OpenAPI, REST, HTML, Apache\n
        ✔ Languages: Java (15+ yrs), Python, Perl, C++, Object oriented patterns\n
        ✔ Tools: IntelliJ, Eclipse, Virtual Box, Vagrant, Git, CVS, Maven, Confluence, Perforce, 
        TeamCity, Jira, Citrix\n
        ✔ Server: Kafka, Tomcat, Docker/Microservice (15 yrs), Kubernetes, Spring Boot\n
        ✔ Quality: JUnit, Mockito\n
        ✔ SDE: DataDog, Splunk, ELK, Dynatrace, Moog, PagerDuty
      `,
    },
  ];

  return (
    <div className="flex-container">
      <HeaderAlt />
      <HeroContainer className="landing-section !pb-[104px] !pt-[78px]">
        <p className="tagline fredoka">🤝 Our Trusted Advisors</p>
        <h1 className="headline hero-title !my-0 !max-w-[866px] !font-semibold">
          Together, we are making education affordable, accessible and efficient
        </h1>
        <div className="button-container">
          <OrangeButton
            className="!w-[189px]"
            label="Contact Us"
            onClick={() => navigate('/contact')}
          />
        </div>
      </HeroContainer>
      <h2 className="fredokaOne mb-6 mt-12 text-center text-4xl font-normal leading-[1.5] text-teal-900">
        Our Advisors
      </h2>
      <div className="container grid gap-4">
        {advisoryBoardMembers.map((advisor, index) => {
          const isExpanded = expandedIndexes.includes(index);
          return (
            <div key={index} className="flex justify-center">
              <div
                className="grid w-full max-w-[1232px] grid-cols-1 gap-4 rounded-3xl p-6 md:grid-cols-5 md:gap-0"
                style={{
                  background: 'linear-gradient(136deg, #FFF 8.91%, #F7F7F7 50%)',
                }}
              >
                <div className="flex flex-col gap-2">
                  <img
                    src={advisor.profilePicture}
                    alt={advisor.name}
                    className="mt-4 h-36 w-auto self-center rounded-full object-contain md:self-start"
                  />
                  <div className="flex items-center gap-4">
                    <h5 className="fredoka text-center text-[32px] font-medium text-[#012E33] md:text-start">
                      {advisor.name}
                    </h5>
                    {advisor.references.linkedIn && (
                      <div className="group relative">
                        <a
                          href={advisor.references.linkedIn}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-block"
                        >
                          <img
                            src="/social-media/LinkedinLogo.svg"
                            alt="LinkedIn"
                            className="h-6 w-6"
                          />
                        </a>
                        <span className="absolute bottom-full left-1/2 mb-2 -translate-x-1/2 rounded bg-black px-2 py-1 text-xs text-white opacity-0 transition-opacity group-hover:opacity-100">
                          LinkedIn Profile
                        </span>
                      </div>
                    )}
                    {advisor.references.companyWebsite && (
                      <div className="group relative">
                        <a
                          href={advisor.references.companyWebsite}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-block"
                        >
                          <img
                            src="/social-media/CompanyWebsiteIcon.svg"
                            alt="Company Website"
                            className="h-6 w-6"
                          />
                        </a>
                        <span className="absolute bottom-full left-1/2 mb-2 -translate-x-1/2 rounded bg-black px-2 py-1 text-xs text-white opacity-0 transition-opacity group-hover:opacity-100">
                          Current Company Website
                        </span>
                      </div>
                    )}
                  </div>
                  <p className="fredoka mt-2 max-w-[317px] text-[18px] text-[#678285]">
                    {advisor.role}
                  </p>
                  <p className="fredoka mt-2 max-w-[445px] text-[18px] font-medium text-[#678285]">
                    Area of Expertise: {advisor.expertise}
                  </p>
                </div>
                <div className="my-auto max-w-[502px]">
                  <p
                    className={`fredoka text-lg leading-[26px] tracking-[-0.36px] text-[#678285] ${isExpanded ? '' : 'line-clamp-4'}`}
                  >
                    {advisor.biography.split('\n\n').map((paragraph, i) => (
                      <span key={i}>
                        {paragraph}
                        <br />
                        <br />
                      </span>
                    ))}
                  </p>
                  <button
                    onClick={() => toggleReadMore(index)}
                    className="mt-2 text-teal-600 underline"
                  >
                    {isExpanded ? 'Read Less' : 'Read More'}
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <Box className="mt-7 bg-[#E0F5F5]" sx={{ textAlign: 'center', py: 7 }}>
        <Typography
          className="description !mx-auto !text-[32px] !text-[#012E33] lg:!text-[42px]"
          variant="h4"
          gutterBottom
        >
          Reach out to us
        </Typography>
        <p className="description !mx-auto !max-w-[446px] !px-4 text-center !text-lg lg:!text-[22px]">
          Send us a message using the form below.
        </p>

        <div className="mx-auto mt-12 max-w-[623px]">
          <div className=" mt-5 space-y-8 rounded-[24px] px-4 ">
            <form className="space-y-7">
              <div className="space-y-2">
                <label className="ml-1 flex font-[Fredoka] text-[20px] font-normal leading-[30px] text-[#012E33] ">
                  First Name*
                </label>
                <input
                  type="text"
                  placeholder="Enter your First Name"
                  className="w-full rounded-[16px] border border-[#DCDCDC] bg-white px-3 py-5 font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] focus:outline-none focus:ring-2"
                />
              </div>

              <div className="space-y-2">
                <label className="ml-1 flex font-[Fredoka] text-[20px] font-normal leading-[30px] text-[#012E33]">
                  Last Name*
                </label>
                <input
                  type="text"
                  placeholder="Enter your Last Name"
                  className="w-full rounded-[16px] border border-[#DCDCDC] bg-white px-3 py-5 font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] focus:outline-none focus:ring-2"
                />
              </div>

              <div className="space-y-2">
                <label className="ml-1 flex font-[Fredoka] text-[20px] font-normal leading-[30px] text-[#012E33]">
                  Email*
                </label>
                <input
                  type="email"
                  placeholder="Enter your Email"
                  className="w-full rounded-[16px] border border-[#DCDCDC] bg-white px-3 py-5 font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] focus:outline-none focus:ring-2"
                />
              </div>

              <div className="space-y-2">
                <label className="ml-1 flex font-[Fredoka] text-[20px] font-normal leading-[30px] text-[#012E33]">
                  Company/Organization Name*
                </label>
                <input
                  type="text"
                  placeholder="Enter your Company/Organization Name*"
                  className="w-full rounded-[16px] border border-[#DCDCDC] bg-white px-3 py-5 font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] focus:outline-none focus:ring-2"
                />
              </div>

              <div className="space-y-2">
                <label className="ml- ml-1 flex font-[Fredoka] text-[20px] font-normal leading-[30px] text-[#012E33]">
                  How would you like to partner?
                </label>
                <textarea
                  rows="4"
                  placeholder="Write a message"
                  className="w-full rounded-[16px] border border-[#DCDCDC] bg-white px-3 py-5 font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.16px] text-[#678285] focus:outline-none focus:ring-2"
                ></textarea>
              </div>

              <div className="flex w-full justify-center">
                <OrangeButton className="!w-[189px]" label={'Submit'} />
              </div>
            </form>
          </div>
        </div>
      </Box>

      <Footer />
    </div>
  );
};

export default Advisors;
